import { useMemo } from "react"

import { ADJUSTMENT_REASON_TO_LABEL, ADJUSTMENT_STATUS_TO_LABEL, ADJUSTMENT_TYPE_TO_LABEL } from "../constants"

import { useGetInventoryAdjustmentHistoryUsers } from "./useGetInventoryAdjustmentHistoryUsers"

import { useGetWarehouseOptions } from "@/hooks/useGetWarehouseOptions"
import type { Option } from "@/types/form-fields"

interface UseInventoryAdjustmentHistoryFilterOptionsReturn {
  adjustmentTypeOptions: Option<string>[]
  statusOptions: Option<string>[]
  reasonOptions: Option<string>[]
  warehouseOptions: Option<string>[]
  adjustedByOptions: Option<string>[]
  isFetching: boolean
}

export const useInventoryAdjustmentHistoryFilterOptions = (): UseInventoryAdjustmentHistoryFilterOptionsReturn => {
  const { warehouseOptions, isFetching: isFetchingWarehouses } = useGetWarehouseOptions({ isInventoryRelated: true })
  const { adjustedByOptions, isFetching: isFetchingUsers } = useGetInventoryAdjustmentHistoryUsers()

  const adjustmentTypeOptions = useMemo<Option<string>[]>(
    () => Object.entries(ADJUSTMENT_TYPE_TO_LABEL).map(([value, label]) => ({ value, label })),
    []
  )

  const statusOptions = useMemo<Option<string>[]>(
    () => Object.entries(ADJUSTMENT_STATUS_TO_LABEL).map(([value, label]) => ({ value, label })),
    []
  )

  const reasonOptions = useMemo<Option<string>[]>(
    () => Object.entries(ADJUSTMENT_REASON_TO_LABEL).map(([value, label]) => ({ value, label })),
    []
  )

  return {
    adjustmentTypeOptions,
    statusOptions,
    reasonOptions,
    warehouseOptions,
    adjustedByOptions,
    isFetching: isFetchingWarehouses || isFetchingUsers,
  }
}
